import { createAction, props } from "@ngrx/store"
import { OutstandingBalance, } from "./dashboard.interfaces"

export const fetchOutstandingBalance = createAction(
    '[DashBoard Module] fetch outstanding balance'
)

export const fetchOutstandingBalanceFailed = createAction(
    '[DashBoard Module] STATUS: fetch outstanding balance failed'
)

export const fetchOutstandingBalanceSuccess = createAction(
    '[DashBoard Module] STATUS: fetch outstanding balance success',
    props<{outstandingBalance: OutstandingBalance}>()
)
